import { useEffect, useState } from "react"
import SelectTemplateView from "../components/Templates/SelectTemplateView"
import TemplatesSidebar from "../components/Templates/TemplatesSidebar"
import EditTemplateView from "../components/Templates/EditTemplateView"
import { TemplateContextWrapper } from "../components/Templates/TemplateContext"
import { CatalogBrowserContextWrapper } from "../components/ItemCatalog/CatalogBrowserContext"
import CatalogBrowser from "../components/ItemCatalog/CatalogBrowser"
import { NavigationService } from "../services/navigationService"

type Props = {
  showDeletedView: boolean
  heroImage: string
  navigationService: NavigationService
}

const TemplatesPage = ({ showDeletedView, heroImage, navigationService }: Props) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | undefined>(undefined)
  const [templateHasChanges, setTemplateHasChanges] = useState<boolean>(false)

  const handleTemplateSelect = (templateId: number) => {
    if (templateHasChanges) {
      if (!window.confirm('This template has been edited.\n\nDiscard your changes and select a different template?')) {
        return
      }
    }
    setTemplateHasChanges(false)
    setSelectedTemplateId(templateId)
    navigationService.setHash(templateId.toString())
  }

  useEffect(() => {
    const templateId = navigationService.hash ? parseInt(navigationService.hash) : undefined
    if (templateId) {
      setSelectedTemplateId(navigationService.hash ? parseInt(navigationService.hash) : undefined)
    }
  }, [navigationService.hash])

  const pageContent = selectedTemplateId === undefined
    ? <SelectTemplateView showDeletedView={showDeletedView} />
    : <EditTemplateView
      templateId={selectedTemplateId}
      heroImage={heroImage} showDeletedView={showDeletedView}
      templateHasChanges={templateHasChanges}
      onChange={setTemplateHasChanges}
      onTemplateDeletionChange={() => setSelectedTemplateId(undefined)}
      onSave={setSelectedTemplateId}
    />

  return (
    <CatalogBrowserContextWrapper allowDragging={true} showTemplates={false}>
      <TemplateContextWrapper templateId={selectedTemplateId!} isTemplateDeleted={showDeletedView}>
        <TemplatesSidebar
          showDeletedView={showDeletedView}
          selectedTemplateId={selectedTemplateId}
          onTemplateSelect={handleTemplateSelect}
        />
        <div id="main" className="main-template has-elements fluid-container">
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CatalogBrowser />
            {pageContent}
          </div>
        </div>
      </TemplateContextWrapper>
    </CatalogBrowserContextWrapper>
  )
}

export default TemplatesPage
